import Vue from "vue";
import Vuex from "vuex";
import user from "../modules/users";
import general from "../modules/general";
import parent from "../modules/parent";
import challenge from "../modules/challenge";
import help from "../modules/help";
import planning from "../modules/planning";
import progress from "../modules/progress";
import rewards from "../modules/rewards";
import badges from "../modules/badges";
import notifications from "../modules/notifications";
import share from "../modules/share";
import surveys from "../modules/surveys";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    user,
    general,
    parent,
    challenge,
    help,
    planning,
    progress,
    rewards,
    badges,
    notifications,
    share,
    surveys
  }
});